<template>
  <div class="app-page">
    <div class="application-page-header">
      <div class="navigation-panel" @click="goBack">
        <left-outlined />
        <a-button type="link">{{ $t('user.Back') }}</a-button>
      </div>
      <div class="page-title">{{ $t('user.' + $route.meta.title) }}</div>
    </div>

    <div class="appliction-page-success" v-if="jobCompleted">
      <a-result status="success" :title="$t('user.Submitted Successfully')" :sub-title="$t('user.You have successfully submitted your assessment')">
        <template #icon>
          <svg-icon class="msg-icon" icon-class="success"></svg-icon>
        </template>
        <template #extra>
          <div class="btn-group-success">
            <router-link :to="{ path: '/home' }">
              <a-button class="btn-back">
                {{ $t('user.Back to Home') }}
              </a-button>
            </router-link>
            <router-link :to="{ path: '/teams/list' }">
              <a-button class="btn-view" type="primary">
                {{ $t('user.View My Team') }}
              </a-button>
            </router-link>
          </div>
        </template>
      </a-result>
    </div>
    <template v-else>
      <div class="application-page-panel">
        <!-- <div class="application-info-list" style="font-size: 16px">
          <div class="info-title">Name:</div>
          <div clas="info-text">{{ employeeName }}</div>
        </div> -->

        <div class="application-info-list">
          <div class="application-info-item">
            <div class="info-title">{{ $t('user.Name') }}:</div>
            <div clas="info-text">{{ employeeName }}</div>
          </div>
          <div class="application-info-item" v-if="!canEdit">
            <div class="info-title">{{ $t('user.Application Season') }}:</div>
            <div clas="info-text">{{ season }}</div>
          </div>
        </div>

        <template v-if="!isOfflineMode">
          <div class="application-info-list">
            <div class="application-info-item">
              <div class="info-title">{{ $t('user.Current Role') }}:</div>
              <div clas="info-text">{{ currentRole }}</div>
            </div>
            <div class="application-info-item">
              <div class="info-title">{{ $t('user.Theme') }}:</div>
              <div clas="info-text">{{ currentRoleTheme }}</div>
            </div>
          </div>
          <div class="application-info-list">
            <div class="application-info-item">
              <div class="info-title">{{ $t('user.Target Role') }}:</div>
              <div clas="info-text">{{ targetRole }}</div>
            </div>
            <div class="application-info-item">
              <div class="info-title">{{ $t('user.Theme') }}:</div>
              <div clas="info-text">{{ targetRoleTheme }}</div>
            </div>
          </div>
        </template>
        <div class="application-info-table" v-if="panelResult.result">
          <a-table
            class="panel-result-table"
            :columns="[
              {
                title: $t('user.Panel Result'),
                key: 'result',
                width: '30%',
                dataIndex: 'result',
              },
              {
                title: $t('user.Panel Comments'),
                key: 'comments',
                dataIndex: 'comments',
              },
            ]"
            :data-source="[panelResult]"
            :pagination="false"
          >
            <template v-slot:emptyText>
              <Empty />
            </template>
          </a-table>
        </div>
        <a-empty v-else-if="isOfflineMode" description="结果尚未发布" />
        <div class="application-info-list" v-if="!isOfflineMode">
          <div clas="info-text">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</div>
        </div>
      </div>
      <div class="application-page-container" v-if="!isOfflineMode">
        <div class="application-info">
          <div class="application-info-left">
            <ApplyTable class="record-table" v-model:data="applicationRecord" :status="canEdit ? 2 : 0" @chang="tableDataChange" @autoSave="saveLineManagerData(false)" :disabled="!can_approve" />
            <div class="btn-groups" v-if="canEdit">
              <!-- <a-button
                class="btn-save"
                @click="saveLineManagerData"
                :disabled="!can_approve"
              >
                Save
              </a-button> -->
              <template v-if="hasUnfinished">
                <a-popover trigger="click" placement="topLeft">
                  <template #content>
                    <div class="popover-tips" v-if="isEn">
                      <exclamation-circle-filled />
                      Please leave comments on the
                      <span style="text-decoration: underline">job qualification</span>
                      boxes which are not checked.
                    </div>
                    <!-- prettier-ignore -->
                    <div class="popover-tips" v-else>请在未勾选的<span style="text-decoration: underline">岗位要求</span>旁留下评语
                    </div>
                  </template>
                  <a-button class="btn-approve" type="primary" :disabled="!can_approve">
                    {{ $t('user.Approve for Panel') }}
                  </a-button>
                </a-popover>
                <a-popover trigger="click" placement="topLeft">
                  <template #content>
                    <div class="popover-tips" v-if="isEn">
                      <exclamation-circle-filled />
                      Please leave comments on the
                      <span style="text-decoration: underline">job qualification</span>
                      boxes which are not checked.
                    </div>
                    <!-- prettier-ignore -->
                    <div class="popover-tips" v-else>请在未勾选的<span style="text-decoration: underline">岗位要求</span>旁留下评语
                      </div>
                  </template>
                  <a-button class="btn-disapprove" type="primary" :disabled="!can_approve">
                    {{ $t('user.Disapprove for Panel') }}
                  </a-button>
                </a-popover>
              </template>
              <template v-else>
                <a-button class="btn-approve" type="primary" @click="approveApplication" :disabled="!can_approve">
                  {{ $t('user.Approve for Panel') }}
                </a-button>
                <a-button class="btn-disapprove" type="primary" @click="disApproveApplication" :disabled="!can_approve">
                  {{ $t('user.Disapprove for Panel') }}
                </a-button>
              </template>
            </div>
            <div class="btn-groups" v-else>
              <a-button class="btn-back-bottom" type="primary" @click="$router.back()">
                {{ $t('user.Back') }}
              </a-button>
            </div>
          </div>
          <div class="application-info-right">
            <div class="application-info-right-list">
              <div class="application-info-right-list-top">
                <div class="application-info-header">
                  <div class="application-info-title question-circle">
                    <span>{{ $t('user.Learning') }}</span>
                    <a-tooltip v-if="canEdit">
                      <template #title>
                        {{ $t('user.√ and × are marked based on the valid record of training attendance. Talent who submitted the ROAR application has completed all the mandatory courses. You can also share your comments on the learning part.') }}
                      </template>
                      &nbsp;
                      <QuestionCircleFilled :style="{ fontSize: '14px' }" />
                    </a-tooltip>
                  </div>
                </div>
                <div class="application-info-sub-header">
                  <div class="application-info-title">
                    {{ $t('user.Mandatory') }}
                  </div>
                </div>
                <div v-for="(doc, index) in docs" :key="index" class="application-info-content">
                  <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                  <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                  <div :class="{ 'doc-highlight': doc.type == 'doc_highlight' }">
                    {{ doc.f }}
                  </div>
                </div>
                <!-- <div
              :class="`jinfo-content ${
                jobInfo.resources == null ? 'default' : 'list'
              }`"
              v-html="
                jobInfo.resources ||
                'Please select role to see learning resources.'
              "
            ></div> -->
                <div class="application-info-sub-header" v-if="docs_optional.length > 0">
                  <div class="application-info-title">
                    {{ $t('user.Optional') }}
                  </div>
                </div>
                <div v-for="(doc, index) in docs_optional" :key="index" class="application-info-content">
                  <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                  <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                  <div :class="{ 'doc-highlight': doc.type == 'doc_highlight' }">
                    {{ doc.f }}
                  </div>
                </div>
              </div>
              <div class="application-info-right-list-bottom">
                <div class="application-info-footer">
                  <div class="application-info-comment">
                    <label class="application-info-title">
                      {{ $t('user.Employee') }}
                    </label>
                    <div class="application-info-comment-detail">
                      <div class="jinfo-content comments">
                        <a-popover v-model:visible="commentsViewPopoverVisible" v-if="comment != '' && comment != null" placement="bottom">
                          <template #content>
                            <div class="comments-view-popover">
                              <div class="comments-view-text">
                                {{ comment }}
                              </div>
                            </div>
                          </template>
                          <a-button type="link">
                            <svg-icon color="#ac7f40" icon-class="search-view"></svg-icon>
                            <span>&nbsp;{{ $t('user.View Comments') }}</span>
                          </a-button>
                        </a-popover>
                        <span v-else>{{ $t('user.No Comments') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="application-info-comment">
                    <label class="application-info-title">
                      {{ $t('user.Review Manager') }}
                    </label>
                    <CommentsEditor
                      v-model:text="lm_comment"
                      :status="canEdit ? 'edit' : 'view'"
                      @autoSave="
                        () => {
                          saveLineManagerData(false)
                        }
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 线下模式的返回按钮 -->
      <div class="application-page-container" v-if="isOfflineMode">
        <div class="btn-groups">
          <a-button class="btn-back-bottom" type="primary" @click="$router.back()">
            {{ $t('user.Back') }}
          </a-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { Modal, message } from 'ant-design-vue'
  import { getTeamsApplicationDetail, saveApplication, approveApplication, disapproveApplication } from '@/api/index'
  import ApplyTable from '@/components/ApplyTable'
  import { mapActions, mapGetters } from 'vuex'
  import { ExclamationCircleFilled, LeftOutlined, CheckOutlined, CloseOutlined, QuestionCircleFilled } from '@ant-design/icons-vue'
  import CommentsEditor from '@/components/CommentsEditor'
  import i18n from '@/locales'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      LeftOutlined,
      ApplyTable,
      ExclamationCircleFilled,
      CommentsEditor,
      CheckOutlined,
      CloseOutlined,
      QuestionCircleFilled,
      Empty,
    },
    data() {
      return {
        hasEdited: false,
        jobCompleted: false,
        title: 'My Team Applications',
        currentRole: null,
        targetRole: null,
        currentRoleTheme: null,
        targetRoleTheme: null,
        employeeName: null,
        applicationRecord: [],
        status: 0,
        can_approve: false,
        panelResult: {},
        comment: null,
        lm_comment: null,
        current_guide: {},
        season: null,
        commentsViewPopoverVisible: false,
      }
    },
    watch: {
      watchData: {
        handler(val, old) {
          if (val.length != 0 && val.length === old.length) {
            // console.log(val, old, 'watchData')
            this.hasEdited = true
          }
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({
        applicationApprovalPeriod: 'user/applicationApprovalPeriod',
        offlineMode: 'user/offlineMode',
      }),
      isOfflineMode() {
        return this.offlineMode
      },
      canEdit() {
        return this.status === 1 && this.can_approve
      },
      watchData() {
        return JSON.parse(JSON.stringify(this.applicationRecord))
      },
      hasUnfinished() {
        const rows = this.applicationRecord.find((item) => {
          return item.t_qualified != true && (item.t_comments == '' || item.t_comments == null)
        })

        return rows != null
      },
      docs() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      docs_optional() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs_optional
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs_optional
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
    mounted() {
      // this.title = this.$route.meta?.title
      const aId = this.$route.params.id
      if (aId) {
        getTeamsApplicationDetail(aId).then((res) => {
          if (res.code == 200) {
            const { current, target } = res.data
            this.currentRole = current
            this.currentRoleTheme = res.data.current_theme
            this.targetRole = target
            this.targetRoleTheme = res.data.target_theme
            this.employeeName = res.data.name
            this.status = res.data.status
            this.can_approve = res.data.can_approve
            this.comment = res.data.comment
            this.lm_comment = res.data.lm_comment
            this.current_guide = res.data.current_guide
            this.season = res.data.season

            if (res.data.PanelResult) {
              this.panelResult = {
                result: res.data.PanelResult,
                comments: res.data.PanelComments,
              }
            }

            const tableData = {}
            res.data.items.forEach((item) => {
              tableData[item.key] = {
                id: item.key,
                content: item.value,
                style: item.style,
              }
            })
            res.data.self_comments.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].e_qualified = item.check
                tableData[index].e_comments = item.comments
              }
            })
            res.data.lm_comments.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].t_qualified = item.check
                tableData[index].t_comments = item.comments
              }
            })
            this.applicationRecord = Object.keys(tableData).map((key) => {
              return { ...tableData[key] }
            })

            console.log(this.applicationRecord)
          }
        })
      }
    },
    methods: {
      getIndicatorStatusClass(data) {
        if (data.result === 'Pending') {
          return 'pending'
        } else if (data.result === 'Approve for Panel') {
          return 'success'
        } else if (data.result === 'Disapprove for Panel') {
          return 'error'
        } else {
          return 'unknow'
        }
      },
      saveLineManagerData(showMsg = true) {
        const aId = this.$route.params.id
        const data = {
          // guide_id: aId,
          items: this.applicationRecord.map((item) => {
            return {
              id: item.id,
              check: item.t_qualified,
              comments: item.t_comments,
            }
          }),
          comment: this.comment,
          lm_comment: this.lm_comment,
        }
        return saveApplication(aId, data).then((res) => {
          if (showMsg) {
            Modal.info({
              title: 'Save Information',
              content: 'Your assessment has been saved',
            })
          }
          return res
        })
      },
      approveApplication() {
        const vm = this
        if (this.hasUnfinished) {
          return
        }
        this.saveLineManagerData(false).then((res) => {
          const aId = this.$route.params.id
          Modal.confirm({
            title: this.$t('user.Submit Information'),
            okText: this.$t('user.Yes'),
            cancelText: this.$t('user.No'),
            closable: true,
            content: this.$t('user.You have approved this employee for panel review. Are you sure you want to proceed?'),
            onOk() {
              return approveApplication(aId).then((res) => {
                if (res.code === 200) {
                  vm.status = 2
                  vm.jobCompleted = true
                } else if (res.code === 300601) {
                  message.info('Completed submission.')
                }
              })
            },
          })
        })
      },
      disApproveApplication() {
        const vm = this
        if (this.hasUnfinished) {
          return
        }
        this.saveLineManagerData(false).then((res) => {
          const aId = this.$route.params.id
          Modal.confirm({
            title: this.$t('user.Submit Information'),
            okText: this.$t('user.Yes'),
            cancelText: this.$t('user.No'),
            closable: true,
            content: this.$t('user.You have disapproved this employee for panel review，Are you sure you want to proceed?'),
            onOk() {
              return disapproveApplication(aId).then((res) => {
                if (res.code === 200) {
                  vm.status = -1
                  vm.jobCompleted = true
                } else if (res.code === 300601) {
                  message.info('Completed submission.')
                }
              })
            },
          })
        })
      },
      tableDataChange() {
        this.hasEdited = true
      },
      goBack() {
        const vm = this
        if (this.hasEdited) {
          Modal.confirm({
            title: this.$t('user.Back to The Previous Page'),
            okText: this.$t('user.Yes'),
            cancelText: this.$t('user.No'),
            closable: true,
            content: this.$t('user.Are you sure you want to leave the page? The information will be saved after you leave the page'),
            onOk() {
              vm.$router.push({ path: '/teams/list' })
            },
          })
        } else {
          this.$router.back()
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .appliction-page-success {
    height: 495px;
    padding-top: 68px;
    background-color: white;
    margin: 16px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    .msg-icon {
      width: 72px;
      height: 72px;
      color: #43a047;
    }
    .btn-group-success {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      .btn-view,
      .btn-back {
        margin: 0 8px;
      }
    }
  }
  .application-page-header {
    background-color: white;
    padding: 8px 32px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    .page-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }
    .navigation-panel {
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      .ant-btn,
      .anticon {
        font-size: 14px;
        color: #333333;
      }
    }
  }

  .application-page-panel {
    background-color: white;
    margin: @app-conetent-margin;

    font-size: 16px;
    color: #333;
    line-height: 24px;
  }

  .application-page-container {
    margin: @app-conetent-margin;
    .btn-groups {
        &.no-padding {
            padding: 0 !important;
        }
    }
    // background-color: white;
  }

  .application-info {
    display: flex;

    &-left {
      background-color: white;
      flex-grow: 7;
      width: 70%;
      margin-right: 16px;
    }

    &-right {
      background-color: white;
      flex-grow: 3;
      width: 30%;
      position: relative;

      &-list {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    &-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }
    &-title {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-weight: 700;

      &.question-circle {
        display: flex;
        align-items: center;
        span {
          margin-right: 2px;
        }
      }
    }

    &-sub-header {
      padding: 16px 24px;
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    &-content {
      padding: 0px 24px;
      padding-bottom: 14px;
      white-space: pre-line;
      display: flex;
      &.list {
        padding: 16px 24px;
      }
      &.default {
        padding: 14px 24px;
      }
      div {
        padding-left: 8px;
        position: relative;
        top: -2px;
      }

      .doc-highlight {
        color: @primary-color;
      }
    }

    &-comment {
      display: flex;
      align-items: center;
      padding: 16px 24px;
    }

    &-footer {
      // position: absolute;
      padding-bottom: 16px;
      // bottom: 0;

      label {
        &::after {
          content: ':';
          margin: 0 8px 0 2px;
          position: relative;
          top: -0.5px;
        }
      }
    }
  }

  .application-info-list {
    padding: 16px 24px;
    display: flex;

    font-size: 14px;
    color: #333333;
    line-height: 22px;

    .application-info-item {
      display: flex;
      min-width: 500px;
    }
    .info-title {
      font-weight: bold;
      margin-right: 12px;
    }
  }
  .record-table {
    padding: 16px 24px;
  }
  .btn-groups {
    padding: 18px 24px 24px 24px;
    .ant-btn {
      margin-right: 16px;
    }
  }
  .popover-tips {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    .anticon {
      color: #faba16;
    }
  }
  .application-info-table {
    padding: 8px 24px;
  }
  .application-info-comment {
    padding: 0 24px;
    padding-bottom: 8px;
  }
  .panel-result-table td {
    word-break: break-word;
  }
  .btn-back-bottom {
    line-height: 22px;
    font-weight: bold;
    padding: 0 30px;
  }
</style>
